module.exports = __webpack_public_path__ + "static/media/share.3f5ff6a7.png";